import { DialogContent, DialogTitle } from '@material-ui/core'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'

export class ConfirmDialogView extends Component {
  render () {
    const { text } = this.props
    return (
      <div>
        <DialogTitle id='form-dialog-title'>Confirmar</DialogTitle>
        <DialogContent>
          <Row>
            <Col md={12}>
              {text}
            </Col>
          </Row>
        </DialogContent>
      </div>
    )
  }
}
